<template>
    <div class="container">
        <div id="content">
            <!--<div v-html="content"></div>-->
            <!--<page-content/>-->
        </div>
        <next-projects :list="projects"/>
    </div>

</template>

<script>

    import axios from 'axios';
    import Vue from 'vue';
    import NextProjects from "@/components/NextProjects";
    import AppSettings from '@/AppSettings';

    export default {
        // components:{
        //   'pageContent': ()=> import('./assets/pages/async.vue')
        // },
        components: {NextProjects},
        name: 'page',
        data() {
            return {
                content: ''
            }
        },
        computed: {
            projects() {
                return AppSettings.instance.getNextProjects(this.$route.params.name);
            }
        },
        mounted() {
            axios.get(`/static/projects/${this.$route.params.name}/content.html?${Date.now()}`)
                .then(response => {
                    // this.content = response.data;
                    const Component = Vue.extend({template: response.data});
                    new Component().$mount('#content');

                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
</script>

<style scoped>
    .container {
        padding-top: 1rem;
        padding-bottom: 1.5rem;
        padding-left: 0.2rem;
        padding-right: 0.2rem;
    }


</style>
